import React from "react";
import styles from "./styles.module.css";

const List = ({ text }) => {
  return (
    <>
      {text.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </>
  );
};

const Audience = ({ audience }) => (
  <>
    <div className={styles.root}>
      <div className={styles.flex}>
        <img
          className={styles.icon}
          alt={"иконка раздела «Целевая аудитория»"}
          src="https://images.ctfassets.net/67gkhzpoimdx/6P5Q0YEx97cvbk4dKCARsx/6a24a5986890cf460239f4ac8f8153fb/audience.svg"
        />
        <span className={styles.title}>Кому подойдет</span>
      </div>
      <ul className={styles.list}>
        {audience.map((item, i) => (
          <List key={i} text={item.text} />
        ))}
      </ul>
    </div>
  </>
);

export default Audience;
